import { ShareholderDividendComponent } from './shareholder-dividend/shareholder-dividend.component';
import { ShareholderEditComponent } from './shareholder-edit.component';
import { ShareholderEditModalComponent } from './shareholder-edit-modal/shareholder-edit-modal.component';
import {
  ShareholderNewComponent,
  ShareholderPinModalComponent
} from './shareholder-new';
import {
  ShareholderPlanDetailEditComponent,
  ShareholderPlanDetailEditModalComponent,
  ShareholderPlanDetailListComponent
} from './shareholder-plan-detail';
import {
  ShareholderPlanEditComponent,
  ShareholderPlanEditModalComponent,
  ShareholderPlanListComponent
} from './shareholder-plan';

export const components: any[] = [
  ShareholderDividendComponent,
  ShareholderEditComponent,
  ShareholderEditModalComponent,
  ShareholderNewComponent,
  ShareholderPinModalComponent,
  ShareholderPlanEditComponent,
  ShareholderPlanEditModalComponent,
  ShareholderPlanListComponent,
  ShareholderPlanDetailEditComponent,
  ShareholderPlanDetailEditModalComponent,
  ShareholderPlanDetailListComponent
];

export * from './shareholder-dividend/shareholder-dividend.component';
export * from './shareholder-edit.component';
export * from './shareholder-edit-modal/shareholder-edit-modal.component';
export * from './shareholder-new';
export * from './shareholder-plan';
export * from './shareholder-plan-detail';
